<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";

    import { VotesState } from "../stores/VotesStore";
    import VoteIcon from "./icons/VoteIcon.svelte";

    export let reviewVotes: VotesState;

    const dispatch = createEventDispatcher();

    const toggleVote = (event: Event) => {
        event.stopPropagation();
        dispatch("toggleVote", { reviewId: reviewVotes.reviewId });
    };
</script>

<BaseButton
    class="gw-rv-toggle-vote"
    disabled={reviewVotes.status === STATUS.LOADING}
    aria-disabled={reviewVotes.status === STATUS.LOADING}
    on:click={toggleVote}
    aria-pressed={reviewVotes.isCustomerVoted}
    aria-live="polite"
    ariaLabel={reviewVotes.isCustomerVoted
        ? `Unvote review. ${reviewVotes.votes} votes`
        : `Vote review. ${reviewVotes.votes} votes`}
>
    <div class="gw-rv-toggle-vote__icon-wrapper">
        <Icon
            viewBox="0 0 20 20"
            class={`gw-rv-toggle-vote__icon--${
                reviewVotes.isCustomerVoted ? "voted" : "unvoted"
            }`}
            width="16"
            height="16"
        >
            <VoteIcon />
        </Icon>
    </div>
    <span aria-hidden="true">{reviewVotes.votes || 0}</span>
</BaseButton>

<style lang="postcss">
    :global(.gw-btn.gw-rv-toggle-vote) {
        box-sizing: content-box;
        display: flex;
        align-items: center;
        column-gap: 4px;
        height: 1.25em;
        border: 1px solid #d6d6d6;
        border-radius: 100px;
        padding: 6px 15px 6px 14px;
        cursor: pointer;

        &:hover {
            background: #f0f0f0;
        }

        &:disabled {
            opacity: 0.4;
        }
    }

    .gw-rv-toggle-vote {
        &__icon-wrapper {
            display: flex;
            align-items: center;
            line-height: 1em;
        }
        :global(&__icon--voted) {
            color: rgb(34, 34, 34);
        }

        :global(&__icon--unvoted) {
            color: rgb(153, 153, 153);
        }
    }
</style>
